<template>
  <div>
    <grid :config="{searchFields: ['name']}" :data="users"
          class="u-1-of-1">
      <template v-slot:gridAdd>
        <router-link :to="{name: 'organisation.users.add'}" class="c-button c-button--secondary c-button--small">
          {{$t('organisation.addUser')}}
        </router-link>
      </template>
      <template v-slot:gridHeader>
        <div class="o-layout c-list__row u-padding-horizontal-small">
          <div class="o-layout__item u-1-of-2-at-small">
            {{$t('name')}}
          </div>
          <div class="o-layout__item u-3-of-8-at-small">
            {{$t('role')}}
          </div>
          <div class="o-layout__item u-1-of-8-at-small">
            &nbsp;
          </div>
        </div>
      </template>
      <template v-slot:gridData="{element}">
        <div class="o-layout__item u-1-of-2-at-small">
          {{element.name}}
        </div>
        <div class="o-layout__item u-3-of-8-at-small">
          {{ $t('role.' + element.role) }}
          <sceButton class="c-button--primary c-button--tiny u-margin-left-small"
                     @click="changeRole(element)" :disabled="user.id === element.userId">
            {{$t('changeRole')}}
          </sceButton>
        </div>
        <div class="o-layout__item u-1-of-8-at-small">
          <sceButton class="c-button--secondary c-button--tiny"
                     @click="removeUser(element)" :disabled="user.id === element.userId">
            {{$t('remove')}}
          </sceButton>
        </div>
      </template>
    </grid>
    <modal :shown="roleChange" @closed="element = false">
      <div class="c-panel__dropdown">
        <h4 class="c-panel__label u-margin-bottom-small">
          {{$t('changeRole')}}: {{roleChange.name}}
        </h4>
        <sceSelect :options="$options.roleOptions" v-model="roleSelected" />
        <sceButton v-on:click="roleChange = false" label="cancel"
                class="c-button--small c-button--secondary"/>
        <sceButton v-on:click="updateRole()" label="confirm"
                   class="c-button--small c-button--primary"/>
      </div>
    </modal>
  </div>


</template>

<script>
import sortBy from "lodash/sortBy"

import options from '@/lib/options'

export default {
  name: "userList",
  components: {
    grid: require('client/components/dataGrid.vue').default,
    modal: require('client/components/modal.vue').default,
  },
  roleOptions: options.organisation.roleOptions,
  data: function () {
    return {
      roleChange: false,
      roleSelected: null,
    }
  },
  computed: {
    users: function() {
      return sortBy(this.$store.state.organisationUsers.items, 'name')
    },
    user: function () {
      return this.$store.state.user.instance
    },
  },
  methods: {
    removeUser: function (element) {
      if (element.userId !== this.user.id) {
        this.$modal.show({
          title: this.$t('organisation.removeUser.title'),
          message: this.$t('organisation.removeUser.text', {name: element.name}),
          onConfirm: () => {
            this.$notify.removeAsync(
              this.$t('organisationUser'),
              this.$store.dispatch('organisationUser.remove', element.id)
            )
          }
        })
      }
    },
    changeRole: function (element) {
      if (element.userId === this.user.id) {
        return
      }
      // TODO implement role change logic
      this.roleSelected = element.role
      this.roleChange = element
    },
    updateRole: function() {
      this.roleChange.role = this.roleSelected
      this.$store.dispatch('organisationUser.save', this.roleChange).then(() => {
        this.roleChange = false
      }, err => { this.$notify.error(err); this.roleChange = false})
    },
  },
}
</script>
